import request from '@/api/request'

// 手机号密码登录
export function phonePasswordLogin(merchantId, phone, password) {
  return request.post('/api/mini/user/phone-password-login', {
    merchantId,
    phone,
    password
  })
}

// 手机号密码注册
export function phonePasswordRegister(merchantId, phone, password) {
  return request.post('/api/mini/user/phone-password-register', {
    merchantId,
    phone,
    password
  })
}

// 合作方免密跳转登录：商户身份由服务端配置决定，不需要传商户ID（合作方入口不固定，链接里可能只有 token）
export function partnerTokenLogin(token) {
  return request.post('/api/mini/user/partner-token-login', {
    token
  })
}

// 获取商户列表
export function getMerchantList() {
  return request.get('/api/mini/user/merchants')
}

// 更新用户信息
export function updateUserInfo(data) {
  return request.put('/api/mini/user/info', data)
}

// 出行人管理
export function getTravelerList() {
  return request.get('/api/mini/user/traveler/list')
}

export function addTraveler(data) {
  return request.post('/api/mini/user/traveler/add', data)
}

export function updateTraveler(data) {
  return request.post('/api/mini/user/traveler/update', data)
}

export function deleteTraveler(id) {
  return request.delete(`/api/mini/user/traveler/delete/${id}`)
}
